export default __webpack_public_path__ + "static/media/why-divo-banner.7dff5fbf.jpg";